(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class CmAnnouncementCarousel extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this._panels = Array.from(this.querySelectorAll('.cm-announcement-bar__panel'));
      if (this._panels.length < 2) return;

      this._currentIndex = this._panels.findIndex((panel) => panel.classList.contains('is-active'));
      if (this._currentIndex < 0) {
        this._currentIndex = 0;
        this._panels[0].classList.add('is-active');
      }

      this._duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300;
      this._boundStopAutoplay = this._stopAutoplay.bind(this);
      this._prevButton = this.querySelector('[data-carousel-prev]');
      this._nextButton = this.querySelector('[data-carousel-next]');

      this._prevButton?.addEventListener('click', () => this.go(-1));
      this._nextButton?.addEventListener('click', () => this.go(1));

      this._autoplayEnabled = this.dataset.autoplay === 'true';
      this._autoplaySpeed = Number.parseInt(this.dataset.speed, 10) * 1000 || 5000;

      this._updateAria();
      if (this._autoplayEnabled) this._startAutoplay();

      this.addEventListener('mouseenter', this._boundStopAutoplay);
      this.addEventListener('mouseleave', () => {
        if (this._autoplayEnabled) this._startAutoplay();
      });
      this.addEventListener('focusin', this._boundStopAutoplay);
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget) && this._autoplayEnabled) {
          this._startAutoplay();
        }
      });
    }

    disconnectedCallback() {
      this._stopAutoplay();
    }

    go(delta) {
      if (this._isAnimating) return;

      const nextIndex = (this._currentIndex + delta + this._panels.length) % this._panels.length;
      if (nextIndex === this._currentIndex) return;

      this._showSlide(nextIndex);
    }

    _showSlide(nextIndex) {
      const current = this._panels[this._currentIndex];
      const next = this._panels[nextIndex];

      this._isAnimating = true;
      current.classList.remove('is-active');
      next.classList.add('is-active');
      this._currentIndex = nextIndex;
      this._updateAria();

      window.setTimeout(() => {
        this._isAnimating = false;
      }, this._duration);
    }

    _updateAria() {
      this._panels.forEach((panel, index) => {
        panel.setAttribute('aria-hidden', index === this._currentIndex ? 'false' : 'true');
      });
    }

    _startAutoplay() {
      this._stopAutoplay();
      this._timer = window.setInterval(() => this.go(1), this._autoplaySpeed);
    }

    _stopAutoplay() {
      if (this._timer) {
        window.clearInterval(this._timer);
        this._timer = null;
      }
    }
  }

  if (!customElements.get('cm-announcement-carousel')) {
    customElements.define('cm-announcement-carousel', CmAnnouncementCarousel);
  }

  const initAnnouncementBarClose = (root = document) => {
    const bars = root.querySelectorAll('.cm-announcement-bar[data-close-enabled="true"]');

    bars.forEach((bar) => {
      const sectionId = bar.dataset.sectionId;
      if (!sectionId) return;

      if (bar.dataset.closeInitialized === 'true') return;
      bar.dataset.closeInitialized = 'true';

      const storageKey = `cm-announcement-closed-${sectionId}`;

      if (sessionStorage.getItem(storageKey) === '1') {
        bar.setAttribute('hidden', '');
        return;
      }

      const closeButton = bar.querySelector('[data-announcement-close]');
      if (!closeButton) return;

      closeButton.addEventListener('click', () => {
        bar.setAttribute('hidden', '');
        sessionStorage.setItem(storageKey, '1');
      });
    });
  };

  initAnnouncementBarClose();

  document.addEventListener('shopify:section:load', (event) => {
    initAnnouncementBarClose(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1000px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  (function () {
    const COLLAPSED_MAX = 200;
    const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function markFeaturedImageInView(image) {
      if (image.classList.contains('is-in-view')) return;

      void image.offsetWidth;
      image.classList.add('is-in-view');

      if (REDUCED_MOTION) {
        image.classList.add('is-revealed');
        return;
      }

      image.addEventListener(
        'animationend',
        (event) => {
          if (event.animationName !== 'cm-collection-hero-image-reveal') return;
          image.classList.add('is-revealed');
        },
        { once: true }
      );
    }

    function revealFeaturedImages(root) {
      const scope = root || document;
      const images = scope.querySelectorAll('.collection-hero__featured-image-img');
      if (!images.length) return;

      if (REDUCED_MOTION) {
        images.forEach((image) => markFeaturedImageInView(image));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            markFeaturedImageInView(entry.target);
            obs.unobserve(entry.target);
          });
        },
        {
          rootMargin: '0px 0px -10% 0px',
          threshold: 0,
        }
      );

      images.forEach((image) => {
        if (!image.classList.contains('is-in-view')) {
          observer.observe(image);
        }
      });
    }

    function initDescription(wrap) {
      if (wrap.dataset.cmDescriptionInit === 'true') return;

      const inner = wrap.querySelector('[data-cm-collection-description-inner]');
      const content = wrap.querySelector('.collection-hero__description');
      const controls = wrap.querySelector('[data-cm-collection-description-controls]');
      const toggle = wrap.querySelector('[data-cm-collection-description-toggle]');
      const label = wrap.querySelector('.collection-hero__description-toggle-label');

      if (!inner || !controls || !toggle || !label) return;

      wrap.dataset.cmDescriptionInit = 'true';

      const readMore = wrap.dataset.readMore || 'Read more';
      const readLess = wrap.dataset.readLess || 'Close';

      const contentHeight = content ? content.scrollHeight : inner.scrollHeight;

      if (contentHeight <= COLLAPSED_MAX) {
        wrap.classList.add('is-static');
        controls.hidden = true;
        return;
      }

      inner.style.maxHeight = COLLAPSED_MAX + 'px';

      const setExpanded = (expanded) => {
        wrap.classList.toggle('is-expanded', expanded);
        label.textContent = expanded ? readLess : readMore;
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      };

      const onTransitionEnd = (handler) => {
        const finish = (event) => {
          if (event.propertyName !== 'max-height') return;
          inner.removeEventListener('transitionend', finish);
          handler();
        };
        inner.addEventListener('transitionend', finish);
      };

      toggle.addEventListener('click', () => {
        const isExpanded = wrap.classList.contains('is-expanded');

        if (!isExpanded) {
          setExpanded(true);
          wrap.classList.add('is-expanding');
          const targetHeight = inner.scrollHeight;

          requestAnimationFrame(() => {
            inner.style.maxHeight = targetHeight + 'px';
          });

          onTransitionEnd(() => {
            wrap.classList.remove('is-expanding');
            inner.style.maxHeight = 'none';
          });
        } else {
          const currentHeight = inner.scrollHeight;
          inner.style.maxHeight = currentHeight + 'px';
          setExpanded(false);
          wrap.classList.add('is-collapsing');

          requestAnimationFrame(() => {
            inner.style.maxHeight = COLLAPSED_MAX + 'px';
          });

          onTransitionEnd(() => {
            wrap.classList.remove('is-collapsing');
          });
        }
      });
    }

    function initAll(event) {
      const scope = event?.target || document;
      scope.querySelectorAll('[data-cm-collection-description]').forEach(initDescription);
      revealFeaturedImages(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (function () {
    const DRAG_THRESHOLD = 5;

    function initCollectionTypeTabsDragScroll(list) {
      if (!list || list.dataset.cmDragScrollInit === 'true') return;
      list.dataset.cmDragScrollInit = 'true';

      let isDown = false;
      let hasDragged = false;
      let startX = 0;
      let scrollLeft = 0;
      let activePointerId = null;

      const endDrag = () => {
        if (!isDown) return;

        isDown = false;
        list.classList.remove('is-dragging');

        if (activePointerId !== null) {
          try {
            if (list.hasPointerCapture(activePointerId)) {
              list.releasePointerCapture(activePointerId);
            }
          } catch (error) {
            /* ignore */
          }
          activePointerId = null;
        }

        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
        document.removeEventListener('pointercancel', onPointerUp);
      };

      const onPointerMove = (event) => {
        if (!isDown || event.pointerId !== activePointerId) return;

        const distance = event.clientX - startX;

        if (!hasDragged) {
          if (Math.abs(distance) < DRAG_THRESHOLD) return;
          hasDragged = true;
          list.classList.add('is-dragging');
          list.setPointerCapture(event.pointerId);
        }

        event.preventDefault();
        list.scrollLeft = scrollLeft - distance;
      };

      const onPointerUp = (event) => {
        if (event.pointerId !== activePointerId) return;
        endDrag();
      };

      list.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        isDown = true;
        hasDragged = false;
        startX = event.clientX;
        scrollLeft = list.scrollLeft;
        activePointerId = event.pointerId;

        document.addEventListener('pointermove', onPointerMove);
        document.addEventListener('pointerup', onPointerUp);
        document.addEventListener('pointercancel', onPointerUp);
      });

      window.addEventListener('blur', endDrag);

      list.addEventListener(
        'click',
        (event) => {
          if (!hasDragged) return;
          event.preventDefault();
          event.stopPropagation();
          hasDragged = false;
        },
        true,
      );
    }

    function initAll() {
      document.querySelectorAll('[data-cm-collection-type-tabs-list]').forEach(initCollectionTypeTabsDragScroll);
    }

    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
